import { colTableRef } from './consts';

export default function (editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;
  const style = `
  <style>
  .${pfx} {
    padding: 2px;
  }
  </style>
`;

  let cardItem = `
<div class="card-body" data-gjs-type="card-body">
  <h5 class="card-title">Card title</h5>
  <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>
  <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
  <a href="#" class="card-link">Card link</a>
  <a href="#" class="card-link">Another link</a>
</div>`;

  let card = `

  <div class="dc-cards col-12" data-js="drapcode-card" data-gjs-type="drapcode-card">
    <div class="card" data-gjs-type="card">
      ${cardItem}
    </div>
  </div>
`;

  if (c.blocks.indexOf(colTableRef) >= 0) {
    bm.add(colTableRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg>
          <div class="gjs-block-label">
          ${c.labelTable}</div>`,
      category: c.labelCMSCategory,
      content: `
        <div class='${pfx} p-3 width100' style="width:100%" data-js="data-group" data-gjs-type="data-group">
          <form class="search-form form-inline dc-form-default" data-gjs="search-form" data-gjs-type="search-form" style="justify-content: space-between;">
            <input class="input form-control form-control-sm mb-2 mr-sm-2" type="text" name="search" 
            value="" placeholder="Search"/>
            <div style="flex-grow: 0.96;justify-content: flex-end;display: inline-flex;">
              <button type="submit" class="btn btn-sm btn-primary mb-2 mr-0">Search</button>
              <button type="submit" class="btn btn-sm btn-success mb-2 mr-0 ms-2 ml-2" value="export">Download CSV</button>
            </div>
          </form>  
          ${card}
          <div class="pagination" data-gjs-type="pagination"  data-gjs="pagination">
            <button type="button"  class="btn btn-sm btn-outline-primary loadMore">Load More Records</button>
          </div>   
        </div>
        ${style}          `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/cms-component-data-group" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelTable
      }?"></i>
          </a>
        </span>
      `,
    });
    bm.add(colTableRef + 'frequently_used', {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg>
          <div class="gjs-block-label">
          ${c.labelTable}</div>`,
      category: 'Frequently Used',
      attributes: {
        style: 'order: 4',
      },
      content: `
        <div class='${pfx} p-3 width100' style="width:100%" data-js="data-group" data-gjs-type="data-group">
          <form class="search-form form-inline dc-form-default" data-gjs="search-form" data-gjs-type="search-form" style="justify-content: space-between;">
            <input class="input form-control form-control-sm mb-2 mr-sm-2" type="text" name="search" 
            value="" placeholder="Search"/>
            <div style="flex-grow: 0.96;justify-content: flex-end;display: inline-flex;">
              <button type="submit" class="btn btn-sm btn-primary mb-2 mr-0">Search</button>
              <button type="submit" class="btn btn-sm btn-success mb-2 mr-0" value="export">Download CSV</button>
            </div>
          </form>  
          ${card}
          <div class="pagination" data-gjs-type="pagination"  data-gjs="pagination">
            <button type="button"  class="btn btn-sm btn-outline-primary loadMore">Load More Records</button>
          </div>   
        </div>
        ${style}          `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
        ${model.get('label')}
        </div>
  
        <span class="${className}__info">
          <a target="_blank" href="https://academy.drapcode.com/docs/app-builder/cms-component-data-group" draggable="false">
            <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelTable
      }?"></i>
          </a>
        </span>
      `,
    });
  }
}
